// extracted by mini-css-extract-plugin
export default {"wrapper":"vWmarXT03_DG0SeX_M9L","rtl":"OGsAwOP7ZFuwWKJHTeJ0","modalText":"meK_lkTk9LQhoHOsMAdu","loadingWrapper":"Ct5c3bmPvxIfosYhtdVt"};